import { RoundCreator } from '../../common/phaser/model/round-creator';
import { BlocksDealer } from '../logic/dealer/blocks-dealer';
import { BlocksGameLogic, BlocksLogicAction } from '../logic/blocks-game-logic';
import { BlocksGameBuilder } from '../logic/blocks-game-builder';
import { BlocksRemoteRoundParams } from './blocks-remote-round-params';
import { BlocksLocalRoundParams } from './blocks-local-round-params';
import { RoundParams } from '../../common/phaser/model/round-params';
import { GameRound } from '../../common/phaser/model/game-round';
import { BlocksGameRound } from './blocks-game-round';
import { Subject } from 'rxjs';
import { ActionBus } from 'game-logic';
import { BlocksListener } from '../game/blocks-listener';

export class BlocksRoundCreator extends RoundCreator {
  public get currentRound(): BlocksGameRound | undefined {
    return this._currentRound;
  }
  private _blocksLogicActionBus = new Subject<ActionBus<BlocksLogicAction> | null>();
  public get blocksLogicActionBus$() {
    return this._blocksLogicActionBus.asObservable();
  }

  private gameListener: BlocksListener;
  private _currentRound: BlocksGameRound | undefined;

  constructor(gameListener: BlocksListener) {
    super();

    this.gameListener = gameListener;
  }

  public override startNewRound(roundParams: RoundParams): GameRound {
    this.destroyCurrentGame();

    let nextRound: BlocksGameRound;
    if (BlocksRemoteRoundParams.isRound(roundParams)) {
      nextRound = this.createRemoteRound(roundParams);
    } else if (BlocksLocalRoundParams.isRound(roundParams)) {
      nextRound = this.createLocalRound(roundParams);
    } else {
      throw new Error('Failed to create new round');
    }

    nextRound.onGameStateChangedAction = (state) => {
      this.gameListener.onGameStateChange(state);
    };
    nextRound.gameLogicActions.on('onMoveExecuted', (payload) => {
      this.gameListener.onNewMove(payload.moves);
    });
    nextRound.gameLogicActions.on('onMultiplierChanged', (payload) => {
      this.gameListener.onMultiplierChange(payload.value);
    });
    nextRound.gameLogicActions.on('onLevelChanged', (payload) => {
      this.gameListener.onLevelChange(payload.value);
    });
    nextRound.gameLogicActions.on('onScoreChanged', (payload) => {
      this.gameListener.onScoreChange(payload.value);
    });

    this._currentRound = nextRound;
    this._blocksLogicActionBus.next(nextRound.gameLogicActions);
    return nextRound;
  }

  public override createRemoteRoundParams(gameListener: BlocksListener): RoundParams {
    return BlocksRemoteRoundParams.create(gameListener);
  }

  public override createLocalRoundParams(gameListener: BlocksListener): RoundParams {
    return BlocksLocalRoundParams.create(gameListener);
  }

  private createRemoteRound(remoteRoundParams: BlocksRemoteRoundParams): BlocksGameRound {
    const gameLogic = BlocksRoundCreator.createGame(remoteRoundParams.dealer);

    return new BlocksGameRound(gameLogic, remoteRoundParams);
  }

  private createLocalRound(localRoundParams: BlocksLocalRoundParams): BlocksGameRound {
    const gameLogic = BlocksRoundCreator.createGame(localRoundParams.dealer);

    return new BlocksGameRound(gameLogic, localRoundParams);
  }

  private destroyCurrentGame(): void {
    // TODO: We still need to call this
    if (this._currentRound) {
      this._blocksLogicActionBus.next(null);
    }
  }

  private static createGame(dealer: BlocksDealer): BlocksGameLogic {
    return BlocksGameBuilder.newGame(dealer);
  }
}
